import {zonedDayBounds} from './display-timezone.js';
import {activityDayBounds,validDateKey} from './activity-model.js';
export const MAX_ROUTE_WINDOW_MS=31*86400000+3600000;
export function routeRange(startDate,endDate,timeZone='Europe/Copenhagen'){
 if(!validDateKey(startDate)||!validDateKey(endDate)||endDate<startDate||Date.parse(endDate)-Date.parse(startDate)>=31*86400000)return null;
 try{return {startAt:zonedDayBounds(startDate,timeZone).startAt,endAt:zonedDayBounds(endDate,timeZone).endAt};}catch{return null;}
}
